<template>
  <div class="wrap-thumb-preview" @click="$emit('onChangePack', indexItem)">
    <div class="gf_button_item__btn gf_button_item__btn_btn-small" :style="itemStyle.button">
      <template v-if="IS_SETTING_ICON_IN_BUTTON">
        <span v-if="item.value.buttonStyle == TEXT_BUTTON" class="btn-text gf_button_item__btn__title">{{
          titleButton(item)
        }}</span>
        <span
          v-else-if="item.value.buttonStyle == ICON_BUTTON"
          class="icon"
          :style="itemStyle.icon"
          v-html="displayIcon(item.value.icon)"></span>
        <template v-else>
          <span
            v-show="item.value.iconPosition == BEFORE_ICON_POSITION"
            class="gf_button_item__btn__icon gf_button_item__btn__icon--left"
            :style="itemStyle.icon"
            v-html="displayIcon(item.value.icon)"></span>
          <span class="btn-text gf_button_item__btn__title">{{ titleButton(item) }}</span>
          <span
            v-show="item.value.iconPosition == AFTER_ICON_POSITION"
            class="gf_button_item__btn__icon gf_button_item__btn__icon--right"
            :style="itemStyle.icon"
            v-html="displayIcon(item.value.icon)"></span>
        </template>
      </template>
      <template v-else>
        <span class="btn-text gf_button_item__btn__title">{{ titleButton(item) }}</span>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ButtonMixin from '../../utils/mixins/Button';
import { mapState } from 'vuex';
import HELPER from '@/app/utils/HELPER';

export default defineComponent({
  name: 'ButtonItem',
  mixins: [ButtonMixin],
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    itemStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
    indexItem: {
      type: Number,
      default: -1,
    },
  },
  emits: ['onChangePack'],
  data() {
    return {};
  },
  computed: {
    ...mapState('sidebar', {
      currentPreset: (state: any) => state.currentPreset,
    }),
  },
  methods: {
    displayIcon(icon: any) {
      return HELPER.base64UrlDecode(icon);
    },
  },
});
</script>

<style lang="scss" scoped>
.wrap-thumb-preview {
  background: #f2e8f7;
  width: 96px;
  height: 48px;
  display: flex;
  padding: 12px 4px;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  overflow: hidden;
}

.gf_button_item__btn {
  line-height: 1;
  display: flex;
  align-items: center;
  max-width: 87px;
  &__title {
    white-space: nowrap;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
  &__icon {
    &--left {
      margin-right: 4px;
    }
    &--right {
      margin-left: 4px;
    }
  }
}
</style>
